import { doc, getDoc, writeBatch, serverTimestamp, arrayRemove } from 'firebase/firestore';
import { db } from '../../config';
import { groupsRef } from './read';
import { usersRef } from '../user/read';
import { groupStatus } from '../../../../constants/enum';

/**
 * グループを論理削除する（#2804）
 * - グループを status=deleted に更新
 * - 所属ユーザーの users.group_ids から当該 group_id を除去（双方向同期）
 * 以上を同一バッチで原子的に実行する。
 *
 * ※ 当該グループ限定で共有されていたパターン/OCR結果の share_scope は
 *   意図的に変更しない（機密保持優先・2026-06 確定。設計書 §4.4 参照）。
 *   'company' に戻すと機密パターンが全社公開されてしまうため放置とし、
 *   ユーザーには削除前ダイアログで閲覧不可になる旨を注意喚起する。
 */
export const deleteGroup = async (
  companyId: string,
  groupId: string,
  updatedBy: string,
): Promise<void> => {
  const groupDocRef = doc(groupsRef(companyId), groupId);
  const snapshot = await getDoc(groupDocRef);
  if (!snapshot.exists()) {
    throw new Error('グループが見つかりません');
  }
  const memberIds: string[] = snapshot.data().member_ids ?? [];

  const batch = writeBatch(db);
  const now = serverTimestamp();

  // 1. グループを論理削除
  batch.update(groupDocRef, {
    status: groupStatus.deleted,
    updated_at: now,
    updated_by: updatedBy,
  });

  // 2. 所属ユーザーの group_ids から除去
  memberIds.forEach(userId => {
    batch.update(doc(usersRef, userId), {
      group_ids: arrayRemove(groupId),
    });
  });

  await batch.commit();
};
